import React from "react";
import './contactstyle.css';

export default function Contact()
{
    return(
        <div className="contact" id="Contact">
        <div className="container">
          <div className="content">
            <div className="left-side">
              <div className="address details">
                <i className="fas fa-map-marker-alt" />
                <div className="topic">Address</div>
                <div className="text-one">Udaipur</div>
                <div className="text-two">Rajasthan</div>
              </div>
              <div className="phone details">
                <i className="fas fa-phone-alt" />
                <div className="topic">Phone</div>
                <div className="text-one">+911234567890</div>
              </div>
              <div className="email details">
                <i className="fas fa-envelope" />
                <div className="topic">Email</div>
                <div className="text-one">teatalkpoint@gmail.com</div>
              </div>
            </div>
            <div className="right-side">
              <div className="topic-text">Contact Us</div>
              <p>To get a franchise and to take the first step and become a part of Tea Talk Point Family that is growing rapidly.<br />Enter your details below and we will reach you as soon as possible.</p>
              <form action="#">
                <div className="input-box">
                  <input type="text" placeholder="Enter your name" />
                </div>
                <div className="input-box">
                  <input type="text" placeholder="Enter your email" />
                </div>
                <div className="input-box message-box">
                </div>
                <div className="button">
                  <input type="button" defaultValue="Send Now" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    );
}